// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-advanced-cropper-foreground{background:#fff}.vue-advanced-cropper-background{background:#fff}", "",{"version":3,"sources":["webpack://src/components/image-cropper/ImageCropperOverlay.vue"],"names":[],"mappings":"AAAA,iCAAiC,eAAe,CAAC,iCAAiC,eAAe","sourcesContent":[".vue-advanced-cropper-foreground{background:#fff}.vue-advanced-cropper-background{background:#fff}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
